<template>
    <div class='header'>
        <p class='name'>管理者画面</p>
    </div>
</template>

<script>

export default {
    name: 'Header',
    data () {
        return {
        }
    },
    watch: {
    },
    created () {
    },
    methods: {
    }
}
</script>

<style scoped>

.header {
    display: flex;
    height: 80px;
    padding-top: 15px;
    padding-left: 22px;
    border-bottom: 3px solid #f5f5f5;
}

.name {
    width: 158px;
    font-size: 19px;
    line-height: 50px;
}

.select {
    margin-left: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/admin/Header.vue